/* istanbul ignore file */
// we don't unit test SVGs
import React from 'react'
import PropTypes from 'prop-types'

const SecondStepLogo = props => {
  const paint0IdRef = React.useRef(null)
  const paint1IdRef = React.useRef(null)
  if (!paint0IdRef.current) {
    paint0IdRef.current = `second-step-logo-paint0-${Math.random()
      .toString(36)
      .slice(2, 9)}`
  }
  if (!paint1IdRef.current) {
    paint1IdRef.current = `second-step-logo-paint1-${Math.random()
      .toString(36)
      .slice(2, 9)}`
  }
  const paint0Id = paint0IdRef.current
  const paint1Id = paint1IdRef.current

  return (
    <svg
      data-name="Layer 1"
      fill="none"
      height="100%"
      id="secondstep-logo"
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 150 179"
      width={props.width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M119.959 42.3042C105.436 46.9016 65.906 46.1199 39.0725 69.3485C15.7616 89.5277 26.1288 111.301 71.4239 102.667C78.4845 101.319 79.1376 106.452 74.5505 109.249C-19.3976 155.902 -39.0162 28.8514 100.834 0.932836C121.049 -3.10402 127.734 6.605 131.658 17.6819C135.582 28.7537 134.486 37.7068 119.964 42.3042H119.959Z"
        fill={`url(#${paint0Id})`}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M29.1136 136.463C43.7388 132.195 83.2383 133.866 110.586 111.255C134.344 91.6103 124.476 69.6056 78.9957 77.2113C71.9042 78.3993 71.3694 73.2516 76.0182 70.5621C171 26.0436 187.739 153.51 47.2974 178.256C26.9949 181.835 20.5307 171.977 16.859 160.818C13.1873 149.659 14.4832 140.737 29.1084 136.463H29.1136Z"
        fill={`url(#${paint1Id})`}
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={paint0Id}
          x1="28.0266"
          x2="124.283"
          y1="177.418"
          y2="6.15889"
        >
          <stop stopColor="#7FE3A4" />
          <stop offset="1" stopColor="#93ACFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={paint1Id}
          x1="29.8274"
          x2="116.478"
          y1="175.618"
          y2="0.773257"
        >
          <stop stopColor="#7FE3A4" />
          <stop offset="1" stopColor="#93ACFF" />
        </linearGradient>
      </defs>
    </svg>
  )
}

SecondStepLogo.propTypes = {
  width: PropTypes.string,
}

SecondStepLogo.defaultProps = {
  width: '150px',
}

export default SecondStepLogo
